import { render, staticRenderFns } from "./HrEmployeeRetireRegist.vue?vue&type=template&id=0fbaa538&scoped=true&"
import script from "./HrEmployeeRetireRegist.vue?vue&type=script&lang=js&"
export * from "./HrEmployeeRetireRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbaa538",
  null
  
)

export default component.exports